<div class="flex items-center justify-between px-4 py-2 border-t bg-white">
  <!-- Left spacer -->
  <div class="flex-1"></div>
  
  <!-- Buttons centered -->
  <div class="flex gap-3">
    <nx-default-button
      [label]="'Zurück'"
      [style]="'light'"
      [disabled]="!hasPrevious()"
      (clicked)="onPrevious()">
    </nx-default-button>
    
    <nx-default-button
      [label]="'Weiter'"
      [style]="'light'"
      [disabled]="!hasNext()"
      (clicked)="onNext()">
    </nx-default-button>
  </div>
  
  <!-- Dropdown right -->
  <div class="flex-1 flex justify-end leading-3">
    <nx-edit-select-input
      [showLabel]="false"
      [options]="pageSizeSelectOptions()"
      [ngModel]="pageSize().toString()"
      (ngModelChange)="onPageSizeChange($event)">
    </nx-edit-select-input>
  </div>
</div>
